export const Types = {
    LOAD_ALL_BILLING_GROUPS: "LOAD_ALL_BILLING_GROUPS",
    LOAD_ALL_BILLING_GROUPS_FOR_LIST_PAGE: "LOAD_ALL_BILLING_GROUPS_FOR_LIST_PAGE",
    TOGGLE_BG_SORT: "TOGGLE_BG_SORT",
    BG_GLOBAL_SEARCH: "BG_GLOBAL_SEARCH",
}

export const Detail = {
    LOAD_BILLING_GROUP_DETAIL: "LOAD_ONE_BILLING_GROUP_SUCCESS",
    CLEAR_BILLING_GROUP_DETAIL_PAGE: "CLEAR_BILLING_GROUP_DETAIL_PAGE",
    DELETE_BILLING_GROUP_WARNING: "DELETE_WARNING_FOR_BILLING_GROUP",
}

export const BGSortFields = {
    BG_NAME: "billing_group_name",
    BASE_PRICE: "base_price",
    COUNTRY_COUNT: "country_count",
    SERVICES_COUNT: "services_count",
    VOLUME_AGGREGATION: "volume_aggregation_type",
    LAST_UPDATED: "last_updated",
}

export const BGPricingActionTypes = {
    SET_BG_COUNTRY_PRICING: "SET_BG_COUNTRY_PRICING",

    TOGGLE_ADD_MODAL_BG_PRICING_SCHEME: "TOGGLE_ADD_MODAL_BG_PRICING_SCHEME",
    TOGGLE_ADD_BG_COUNTRY_PRICING_MODAL: "TOGGLE_ADD_BG_COUNTRY_PRICING_MODAL",
    TOGGLE_EDIT_BG_COUNTRY_PRICING_MODAL: "TOGGLE_EDIT_BG_COUNTRY_PRICING_MODAL",

    CLOSE_MODAL_BG_COUNTRY_PRICING: "CLOSE_MODAL_BG_COUNTRY_PRICING",

    SELECT_BG_PRICING_FORM_SCHEME: "SELECT_BG_PRICING_FORM_SCHEME",
    SELECT_BG_PRICING_FORM_COUNTRY: "SELECT_BG_PRICING_FORM_COUNTRY",

    SET_BG_PRICING_FORM_FLAT_PRICE: "SET_BG_PRICING_FORM_FLAT_PRICE",

    ADD_BG_PRICING_FORM_VOLUME_TIER: "ADD_BG_PRICING_FORM_VOLUME_TIER",
    SET_BG_PRICING_FORM_VOLUME_TIER: "SET_BG_PRICING_FORM_VOLUME_TIER",
    DELETE_BG_PRICING_FORM_VOLUME_TIER: "DELETE_BG_PRICING_FORM_VOLUME_TIER",

    SUBMIT_BG_PRICING_FORM: "SUBMIT_BG_PRICING_FORM",

    DELETE_BG_PRICING_WARNING: "DELETE_BG_PRICING_WARNING"
}
